import {
  Container,
  Box,
  Grid,
  IconButton,
  Link,
  Hidden,
  Button,
  Typography,
  Paper,
} from "@mui/material";
// import useStyles from "./styles";
import { useFormContext } from "react-hook-form";

import { CardElement } from "@stripe/react-stripe-js";
import { useSharedBookReducer } from "../state";

const Item = ({ title, singletype }) => {
  const [bookState, dispatch] = useSharedBookReducer();
  const { register, setValue } = useFormContext();

  const selected = bookState.m.singletype === singletype ? true : false;

  const setSingleType = () => {
    setValue("singletype", singletype);
    dispatch({
      type: "MERGE",
      payload: {
        m: { singletype },
      },
    });
  };

  return (
    <Grid item>
      <Box
        sx={{
          backgroundColor: selected ? "#317e5c" : "#ffffff",
          color: selected ? "#ffffff" : "#4a4a4a",
          fontWeight: selected ? 600 : 400,
          borderRadius: "6px",
          boxShadow:
            "0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1)",
          display: "block",
          padding: "1.25rem",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          userSelect: "none",
          "&:hover": {
            boxShadow: "0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px #317e5c",
          },

          // a.box:active {
          //   box-shadow: inset 0 1px 2px rgba(10, 10, 10, 0.2), 0 0 0 1px #3273dc; }
        }}
        variant="outlined"
        onClick={setSingleType}
      >
        <div>{title}</div>
      </Box>
    </Grid>
  );
};

const SurfExperienceLevel = (props) => {
  const [bookState, dispatch] = useSharedBookReducer();
  const { register } = useFormContext();

  return (
    <>
      <Typography variant="h5">Experience Level</Typography>
      <input
        {...register("singletype", { shouldUnregister: true })}
        type="hidden"
        defaultValue={bookState.m.singletype}
      />
      <Grid container spacing={2} wrap="nowrap">
        <Item title="Single Lesson" singletype="single" />
        <Item title="Master Class" singletype="master" />
      </Grid>
    </>
  );
};

export default SurfExperienceLevel;
